import { AppShellManifest } from 'models/AppShellManifest';
import { createReducer } from 'store/createReducer';
import { APPSHELL_CACHE_LOAD, APPSHELL_SET_SITE_MODE, SetSiteModeAction } from './actions';
import { SiteMode } from 'models/SiteMode';

export const initialState: AppShellManifest = {
  version: '',
  links: {
    site: '',
    cdnUrl: '',
    checkout: '',
    receipt: '',
    editorials: '',
    favourites: '',
    social: []
  },
  channel: '',
  navigationHash: -1,
  whitelist: {},
  currencyCode: '',
  logoUrl: '',
  siteMode: SiteMode.Unknown,
  saleShop: '',
  isBot: false,
  isValidated: false,
  currencySymbol: '',
  tinyLogoUrl: '',
  isThecaSearchFeatureToggle: false,
  shouldUseNewCart: false,
  shouldUseHelpCenter: false,
  shouldDisableBackOrders: false,
  shouldUseGecpHeader: false,
  shouldUseIngrid: false,
  shouldShowBHGNewsletter: false
};

const reducer = {
  [APPSHELL_CACHE_LOAD]: (state: AppShellManifest) => {
    return state;
  },
  [APPSHELL_SET_SITE_MODE]: (state: AppShellManifest, action: SetSiteModeAction) => {
    return {
      ...state,
      siteMode: action.siteMode
    };
  }
};

export default createReducer<AppShellManifest>(initialState, reducer);
